function scrollAndFocus(targetId) {
    const target = document.getElementById(targetId);
    if (!target) return;

    // Scroll into view
    target.scrollIntoView({
        behavior: "smooth",
        block: "start"
    });

    // After scrolling, move focus to first focusable element
    setTimeout(function () {
        const focusableSelector = [
            "a[href]",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])",
            "[tabindex]:not([tabindex=\"-1\"])"
        ].join(",");

        const firstFocusable = target.querySelector(focusableSelector);

        if (firstFocusable) {
            firstFocusable.focus();
        } else {
            // Fallback: make the section focusable
            target.setAttribute("tabindex", "-1");
            target.focus();
        }
    }, 300);
}

module.exports = {
    initEvents: function () {
        document.querySelectorAll(".accessible-hidden-scroll-button")
            .forEach(button => {
                button.addEventListener("click", function (e) {
                    e.preventDefault();
                    const target = this.dataset.content;
                    if (target) {
                        scrollAndFocus(target);
                    }
                });
            });
    }
}
